let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gJqWu")).then(() => parcelRequire('8wK7s'));